import React, { FC, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { CustomLeftArrowSvg, CustomRightArrowSvg } from '../../icons';
import { GridItem } from '../../styles/styled';
import { PdfViewerContainerUI } from './styled';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type PdfViewerComponentProps = {
  bookLink: string;
  closePdfViewer: () => void;
};

export const PdfViewerComponent: FC<PdfViewerComponentProps> = ({ bookLink, closePdfViewer }) => {
  const [maxPdfPages, setMaxPdfPages] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);

  return (
    <PdfViewerContainerUI>
      <button onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}>
        <CustomLeftArrowSvg />{' '}
      </button>
      <GridItem width="auto" align="center" justify="center" direction="column" gap="10px">
        <div className="pages-text">
          {currentPage} / {maxPdfPages}
        </div>
        <Document
          file={{ url: bookLink }}
          onLoadSuccess={({ numPages }) => setMaxPdfPages(numPages)}
          renderMode="canvas"
        >
          <Page
            width={550}
            height={500}
            pageNumber={currentPage}
            renderAnnotationLayer={false}
            renderTextLayer={false}
          />
        </Document>
      </GridItem>
      <button onClick={() => setCurrentPage(currentPage < maxPdfPages ? currentPage + 1 : maxPdfPages)}>
        <CustomRightArrowSvg />
      </button>
      <button className="close-button" onClick={() => closePdfViewer()}>
        +
      </button>
    </PdfViewerContainerUI>
  );
};
